/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessageCircleHeart = createReactComponent(
  "message-circle-heart",
  "IconMessageCircleHeart",
  [
    [
      "path",
      {
        d: "M10.59 19.88a9.763 9.763 0 0 1 -2.89 -.88l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.565 1.335 2.479 3.065 2.71 4.861",
        key: "svg-0"
      }
    ],
    [
      "path",
      {
        d: "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z",
        key: "svg-1"
      }
    ]
  ]
);

export { IconMessageCircleHeart as default };
//# sourceMappingURL=IconMessageCircleHeart.js.map
